import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createPickupLocationVehicle = (request) => {
    return vdkEmHappinessPortalApi.post(`/pickup-locations/${request.pickupLocationId}/vehicles`, request);
};
const updatePickupLocationVehicle = (request) => {
    return vdkEmHappinessPortalApi.put(`/vehicles/${request.id}`, request);
};
const getVehiclesByPickupLocationId = (request) => {
    return vdkEmHappinessPortalApi.post('/pickup-locations/get-all/vehicles', request);
};
const getAllVehiclesByPickupLocationId = (pickupLocationId, searchString) => {
    const params = searchString ? { searchString } : {};
    return vdkEmHappinessPortalApi.post(`pickup-locations/vehicles/get-all`, {
        PickupLocationId: pickupLocationId,
        SearchString: searchString
    });
};
const getVehicleById = (id) => {
    return vdkEmHappinessPortalApi.get(`/vehicles/${id}`);
};
const deleteVehicle = (id) => {
    return vdkEmHappinessPortalApi.delete(`/vehicles/${id}`);
};
const pickupLocationVehicleAPI = {
    createPickupLocationVehicle,
    updatePickupLocationVehicle,
    getVehiclesByPickupLocationId,
    getAllVehiclesByPickupLocationId,
    getVehicleById,
    deleteVehicle
};
export default pickupLocationVehicleAPI;
